import React from 'react';
import { Link } from 'react-router-dom';

const landingImages = require.context('../../assets/images', true);
/**
 * Creado por Equilibrio Agency 2022<br>
 * Función de pie de página
 * @function Footer
 */
export const SimpleFooter = () => {
  return (
    <div className="container">
      <div className="row  align-items-center">
        <div className="col-12 col-lg-6 img-copyright">
          <Link to="/">
            <img
              alt="Monet"
              src={landingImages('./monet-logo.png')}
              style={{ width: '320px', height: '80px' }}
            />
          </Link>
        </div>
        <div className="col-12 col-lg-6 text-white">
          <p className="text-footer-small text-copyright mb-0">
            © 2024 Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};
